export const blockIconsImageImage = (
	<span className='material-symbols-outlined'>image</span>
);
